<div class="row pt-2 pb-2">
    <div class="col-sm-9">
        <h4 class="page-title">Install IoT Device</h4>
    </div> 
    <div class="col-sm-3"></div>

</div>

<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <!-- <div class="row p-t-20"> 
					<div class="col-md-3">
                        <div class="form-group">
                            <label class="control-label">Select Date</label>
                            <input type="date" id="dateTime" name="dateTime" class="form-control">
                         </div>
                    </div>
                    <div style="margin-top: 30px;"  class="col-md-2">
                        <button type="button" class="btn btn-outline-info" (click)="ShowReport()">Submit</button>
                    </div>
                </div> -->
                <div class="table-responsive">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                        class="table table-bordered table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Device ID</th>
                                <th style="white-space: normal;">Description</th>
                                <th>Model No.</th>
                                <th>Mfg. Date</th>
                                <th>Assigned Status</th>
                                <th>Version</th>
                                <!-- <th>Action</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let dData of deviceRowdata; let i = index">
                                <td>{{i+1}}</td>
                                <td>{{dData.device_id}}</td>
                                <td>{{dData.description}}</td>
                                <td>{{dData.model_no}}</td>
                                <td>{{dData.manufacturing_date | date:'dd-MM-yyyy'}}</td>
                                <td>{{dData.assigned_status}}</td>
                                <td>{{dData.version}}</td>
                                <!-- <td style="text-align: center;">
                                    <a (click)="EditDevice(dData.id)" style="color: dodgerblue">
                                        <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                                    </a><span style="margin-left: 15px;"></span>
                                    <a (click)="DeleteDevice(dData.id)" style="color: red;">
                                        <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                                    </a>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                    
                </div>
            </div>
        </div>
    </div>
</div>
<div class="loader-wrapper" id="loading" *ngIf="isLoading" >
    <div class="loader-card">
        <div class="spinner">
            <div class="spinner-ring"></div>
            <div class="spinner-ring delay"></div>
            <div class="core"></div>
        </div>
    </div>
</div>